var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DBE729E1-46D9-4E37-8D20-9F2B49E20E36") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Safety-Dashboard-Widgets",
    transform: "translate(-742.000000, -1430.000000)",
    stroke: "#000000",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(743.000000, 1144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DC-black",
    transform: "translate(0.000000, 287.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,10.5 L1.5,10.5 L1.50088151,4.49528951 C0.77207374,4.55446848 0,4.05603865 0,3 C0.219197207,2.21259184 0.731343347,1.33321036 1.53643842,0.361855548 C1.72642209,0.132646657 2.00865065,-1.72166863e-15 2.30635941,-1.77635684e-15 L9.66938849,-1.77635684e-15 C9.98104697,-4.15063378e-05 10.2748884,0.145258008 10.464082,0.392920687 C11.1357223,1.27212735 11.647695,2.14115379 12,3 C12,4.05555556 11.2286325,4.55401235 10.5001187,4.49537037 L10.5,10.5 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30635941,0 L9.66938849,0 C9.98104697,-4.15063378e-05 10.2748884,0.145258008 10.464082,0.392920687 C11.1357223,1.27212735 11.647695,2.14115379 12,3 C12,5 9.23076923,5 9.23076923,3 C9.23076923,5 6,5 6,3 C6,5 2.76923077,5 2.76923077,3 C2.76923077,5 0,5 0,3 C0.219197207,2.21259184 0.731343347,1.33321036 1.53643842,0.361855548 C1.72642209,0.132646657 2.00865065,5.46882135e-17 2.30635941,0 Z",
    id: "Rectangle",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,6.5 C6.82842712,6.5 7.5,7.17157288 7.5,8 L7.5,10.5 L7.5,10.5 L4.5,10.5 L4.5,8 C4.5,7.17157288 5.17157288,6.5 6,6.5 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.83880688e-16,
    y1: 10.5,
    x2: 12,
    y2: 10.5,
    id: "Line-8",
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlack);
export default __webpack_public_path__ + "static/media/home-black.8bc0814b933f470685acca7389c081bb.svg";
export { ForwardRef as ReactComponent };